/**
 * Normalize model-emitted chat text for rendering.
 *
 * Models occasionally emit literal HTML line-break tags (`<br>`, `<br/>`,
 * `<br />`) in their text — especially the short commentary that accompanies a
 * tool call. ReactMarkdown (raw HTML is disabled for safety) and plain text both
 * render those tags VERBATIM, so the user sees a stray "<br>".
 *
 * Convert them to real newlines so they read as line breaks. A break-only
 * message collapses to an empty string (and the caller's `content && …` guard
 * then hides it) instead of showing a lone "<br>". We deliberately do NOT enable
 * rehype-raw — that would pass through ALL model-emitted HTML (XSS surface).
 */
export function normalizeChatText(text) {
  if (!text || typeof text !== 'string') return text;
  return text
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
